import { useCameraStateContext } from "../../contexts/CameraContext";
import useCategories from "./useCategories";
import { useEffect } from "react";
import {getWidth, getHeight, getTransformByBlocks} from "./categoryModel";

function useCategoryCamera () {
    const { panzone } = useCameraStateContext();

    const { getCategoryByObjectId } = useCategories();

    const jumpToPosition = (x, y, cb = () => {}) => {
        panzone.pause();
        panzone.zoomTo(0, 0, 1 / panzone.getTransform().scale);
        panzone.smoothMoveTo(-(x) * panzone.getTransform().scale + 30, -(y - window.innerHeight / 2.5) * panzone.getTransform().scale, cb);
        panzone.resume();
    }

    const followCategory = (id) => {
        if(sessionStorage.getItem('reloaded') == 'true') {
            return sessionStorage.setItem('reloaded', 'false')
        }
        if(!id) return;
        
        const { category } = getCategoryByObjectId(id);
        let blocks = category.categories_blocks.map(b => b.blocks);

        const pos = getTransformByBlocks(blocks)

        if(category == null) return;
        jumpToPosition(pos.x, pos.y + 100);
    }

    const setPageHaveReload = () => {
        sessionStorage.setItem('reloaded', 'true');
    }

    useEffect(() => {
        window.followBlock = followBlock;
    
        window.addEventListener("beforeunload", setPageHaveReload);
    
        return () => {
            window.removeEventListener('beforeunload', setPageHaveReload)
        }

    }, [panzone])

    return { jumpToPosition, followCategory };
}

export default useCategoryCamera;